import { Button } from '@dtx-company/shared-components/src'
import { FlexboxProps, LayoutProps, SpaceProps, flexbox, layout, space } from 'styled-system'
import styled, { css } from 'styled-components'

export const FlowcodeTransparentOverlay = styled.div<{ isTransparent: boolean }>`
  opacity: 1;
  transition: opacity 3s;
  position: relative;
  .flowcode-container {
    position: relative;
  }
  ${props =>
    props.isTransparent &&
    css`
      background: transparent;
      overflow: hidden;
      &:before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        content: '';
        display: block;
        background-image: linear-gradient(45deg, #ccc 25%, transparent 25%),
          linear-gradient(135deg, #ccc 25%, transparent 25%),
          linear-gradient(45deg, transparent 75%, #ccc 75%),
          linear-gradient(135deg, transparent 75%, #ccc 75%);
        background-size: 50px 50px;
        background-position: 0 0, 25px 0, 25px -25px, 0px 25px;
      }
    `}
`

export const DownloadTemplateFormWrapper = styled.div`
  width: 100%;
`

// TODO: create ul in shared components or in this repo w/ the same props as a box
export const StyledUl = styled.ul<SpaceProps & FlexboxProps & LayoutProps>`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  justify-content: space-between;
  width: 100%;
  ${space}
  ${flexbox}
  ${layout}
`
export const StyledLi = styled.li<SpaceProps & FlexboxProps & LayoutProps>`
  list-style: none;
  position: relative;
  ${space}
  ${flexbox}
  ${layout}
`

export const ColorButton = styled(Button)<{ id?: string; title?: string; selected?: boolean }>`
  ${({ disabled }) => disabled && `opacity: 0.6;`}
  :focus {
    border: ${({ selected, theme }) =>
      selected ? `4px solid ${theme.colors.primary.flowBlue}` : '4px solid grey'};
  }
`
